import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useBeats } from '../hooks/useBeats';
import { Solution } from '../data/teaser';
interface TransformStageProps {
  solution: Solution;
}

/**
 * Plays the before → after transformation for one solution.
 * On a "dropBefore" solution the conventional example is removed once the point lands.
 */
export function TransformStage({
  solution
}: TransformStageProps) {
  const beat = useBeats([700, 1600]);
  const landed = beat >= 1;
  const dropped = solution.dropBefore === true && beat >= 2;
  return <div className="flex h-full w-full items-stretch gap-2" data-id="element-122" data-mp="i8wxu2cdac3f">
      <figure className={`relative overflow-hidden rounded-xl border border-white/10 transition-all duration-500 ${dropped ? 'w-0 border-0 opacity-0' : 'flex-1 opacity-100'}`} data-id="element-123" data-mp="w7mszcfmm1p5">
        <img src={solution.before} alt="" aria-hidden="true" className="h-full w-full object-cover" data-id="element-124" data-mp="27kh0kqoq463e" />
        <figcaption className="absolute inset-x-0 bottom-0 bg-black/55 px-2 py-1 font-body text-[10px] uppercase tracking-[0.14em] text-white/70" data-id="element-125" data-mp="3ck67ty08cf7z">
          {solution.beforeLabel}
        </figcaption>
      </figure>

      <div className={`flex flex-shrink-0 items-center transition-all duration-500 ${dropped ? 'w-0 opacity-0' : 'w-5 opacity-100'}`} aria-hidden="true" data-id="element-126" data-mp="3mhsuj6nrtb2i">
        <ArrowRightIcon className={`h-5 w-5 transition-colors duration-300 ${landed ? 'text-solventum-primary' : 'text-white/30'}`} data-id="element-127" data-mp="2tu6olrr2luch" />
      </div>

      <figure className={`relative flex-1 overflow-hidden rounded-xl border transition-all duration-500 ${landed ? 'border-solventum-primary/70 opacity-100' : 'border-white/10 opacity-60'}`} data-id="element-128" data-mp="33s4baata7j2z">
        <img src={solution.after} alt={`${solution.name}: ${solution.cardHeadline}`} className="h-full w-full object-cover" data-id="element-129" data-mp="2b2nlzm0ykiaz" />
        <figcaption className="absolute inset-x-0 bottom-0 bg-solventum-bg/80 px-2 py-1 font-body text-[10px] uppercase tracking-[0.14em] text-solventum-primary" data-id="element-130" data-mp="280smkjy63p1u">
          {solution.afterLabel}
        </figcaption>
      </figure>
    </div>;
}